module.exports = __webpack_public_path__ + "media/puregym-load-up.077c94c8.mp4";